import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "../component/Header.js/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";


const AboutUs = () => {
  const MainBox = styled.div`
    height: fit-content;
    padding: 4rem 4rem;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    @media only screen and (max-width: 1220px) {
      width: 100%;
      padding: 1rem;
    }
  `;

  return (
    <>
      <Navbar />
      <MainBox>
        <h1>About Samriddhi India</h1>
        <p>Beyond the Trend – Redefining Everyday Ethnic Elegance</p>
        <p>Founded in 2023 by Rohit Madhwal, Samriddhi India has quickly become one of the most loved ethnic brands in India. Built on the belief that fashion should be stylish yet comfortable, we bring you designs that celebrate tradition while embracing the spirit of today’s modern woman.</p>
        <p>At Samriddhi India, we curate collections that blend traditional craftsmanship with contemporary silhouettes, so you can look effortlessly elegant wherever you go – be it a festive celebration, an office meeting, or a casual brunch.</p>

        <h3>What We Offer</h3>
        <p>Our product range is thoughtfully designed to cover all your wardrobe and accessory needs:</p>

        <h4>Women’s Top Wear:</h4>
        <p>Printed Suits, Jumpsuits, Neck & Stone Work Gather Jumpsuits, Anarkali Suit Sets, A-Line Tops with Dhoti Pants, Kurti with Palazzo Sets, Floral Kurta Sets, Co-ord Sets, Straight Tops, Flared Dresses, and Dupattas.</p>

        <h4>Handbags & Accessories:</h4>
        <p>Stylish Wallets, Totes & Top-Handle Bags, Clutches, Slings – perfect companions for your everyday and festive looks.</p>

        <h4>Footwear:</h4>
        <p>Trendy Slippers & Slides, Sandals, Mojaris & Mules, Loafers & Choco Shoes, Heels, and Girls’ Footwear – because the right pair completes every outfit.</p>

        <h4>Jewelry:</h4>
        <p>Elegant Earrings, Necklaces & Sets, Rings, Bangles & Bracelets – available in Contemporary and Festive styles to suit every mood and occasion.</p>
        <p>At Samriddhi India, we go Beyond the Trend by creating styles that last, focusing on quality fabrics, intricate detailing, and versatile designs that empower you to express yourself with confidence.</p>
        <p>Join the Samriddhi India family and redefine your ethnic wardrobe – because fashion should always feel like you.</p>
      </MainBox>
      <Footer />
    </>
  );
};

export default AboutUs;
